import { IChangeReservationStatus, ICreateStaffReservation, IReservation, IReservationConfirm, IReservationScheduleItem, IReservationSettings, IReservationSettingsUpdate, IRestaurantTable, IRestaurantTableCreate, IRestaurantTableUpdate, ITableAvailability } from "../models/IReservation";
import { configWithUserToken } from "../../services/config";

export const getPendingReservations = (restaurantId: string) => {
  return configWithUserToken.get<IReservation[]>(
    "Reservation/pending/" + restaurantId
  );
};

export const getRestaurantTables = (restaurantId: string) => {
  return configWithUserToken.get<IRestaurantTable[]>(
    "RestaurantTable/" + restaurantId
  );
};

export const postRestaurantTable = (table: IRestaurantTableCreate) => {
  return configWithUserToken.post<IRestaurantTable>(
    "RestaurantTable", table
  );
};

export const putRestaurantTable = (table: IRestaurantTableUpdate) => {
  return configWithUserToken.put<IRestaurantTable>(
    "RestaurantTable", table
  );
};

export const deleteRestaurantTable = (id: string) => {
  return configWithUserToken.delete(
    "RestaurantTable/" + id
  );
};

export const getTableAvailability = (
  restaurantId: string,
  startsAtUtc: string,
  partySize: number,
  durationMinutes?: number,
) => {
  const p = new URLSearchParams();
  p.append("restourantId", restaurantId);
  p.append("startsAtUtc", startsAtUtc);
  p.append("partySize", String(partySize));
  if (durationMinutes) p.append("durationMinutes", String(durationMinutes));
  return configWithUserToken.get<ITableAvailability[]>(`Reservation/table-availability?${p.toString()}`);
};

export const createStaffReservation = (payload: ICreateStaffReservation) => {
  return configWithUserToken.post<IReservation>("Reservation", payload);
};

export const confirmReservation = (reservationId: string, tableId: string, durationMinutes: number) => {
  const payload: IReservationConfirm = { id: reservationId, tableId, durationMinutes };
  return configWithUserToken.post(
    `Reservation/${reservationId}/confirm`, payload
  );
};

export const changeReservationStatus = (payload: IChangeReservationStatus) => {
  return configWithUserToken.post(`Reservation/${payload.id}/status`, payload);
};

export const getReservationSchedule = (restaurantId: string, fromUtc: string, toUtc: string) => {
  return configWithUserToken.get<IReservationScheduleItem[]>(
    `Reservation/schedule?restourantId=${restaurantId}&fromUtc=${encodeURIComponent(fromUtc)}&toUtc=${encodeURIComponent(toUtc)}`
  );
};

export const getReservationSettings = (restaurantId: string) => {
  return configWithUserToken.get<IReservationSettings>(
    "Reservation/settings/" + restaurantId
  );
};

export const putReservationSettings = (settings: IReservationSettingsUpdate) => {
  return configWithUserToken.put<IReservationSettings>(
    "Reservation/settings", settings
  );
};
